import React, { Component } from 'react';
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { variables } from "./Variables.js"
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { DataGrid, GridColDef, GridValueGetterParams } from '@mui/x-data-grid';
import CsTable from './components/cstable.js';
import { assetCreator } from "./index.js"

import Backend from './backend.js';
import { getToken, getRoles, getUsername } from './TokenController';
import FileDropUploader from './components/FileUploader.jsx';
export default class AssetList extends React.Component {



    constructor(props) {
        super(props);

        this.state = {
            assetid: '',
            assetList: [],
            assetTypes: [],
            assettype : '',
            showAdd: false,
            showGeneric : false,
            preferedName : '',
            name: '',
            selectedId: '',
            description: '',
            parentid: '',
            addError: '',
            showImport : false,
            showAddButton: "hidden"
            
        };

        this.claims = [];
        this.tree = null;
        this.token = '';
        this.backend = new Backend();
        this.gridref = React.createRef();
        this.table = React.createRef();
        this.style = {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '90%',
            bgcolor: 'background.paper',
            border: '2px solid #000',
            boxShadow: 24,
            p: 4,

        };
        /*
          public string id { get; set; }

        public string parentId { get; set; }

        public string text { get; set; }

        public string AssetType { get; set; }

        public bool hasItems { get; set; }

        public string Responsible { get; set; }

        */
        this.GridColDef = [
            {
                field: 'id',
                headerName: 'Position ID',
                width: 150,
                hide: false,
                editable: false,
            },
            {
                field: 'parentId',
                headerName: 'Parent',
                width: 20,
                hide: true,
                editable: false,
            },
            {
                field: 'text',
                headerName: 'Description',
                width: 400,
                editable: false,
            },
            {
                field: 'AssetType',
                headerName: 'Type',
                width: 20,
                hide: true,
                editable: false,
            },
            
            {
                field: 'hasItems',
                headerName: 'hasItems',
                width: 20,
                hide: true,
                editable: false,
            },
            {
                field: 'Responsible',
                headerName: 'Responsible',
                width: 20,
                hide: true,
                editable: false,
            },
            {
                field: 'action',
                headerName: 'Action',
                width: 150,
                renderCell: (params) => (

                    this.renderButton(params.row.id)  
                   
                )
                    
            }
            
        ];       
    }
    handleClose = () => {

        this.setState({ showAdd: false });
    }
    handleCloseGen = () => {

        this.setState({ showGeneric: false });
    }

    
    handleClick(id) {
        this.setState({ preferedName: '', selectedId: id, description: '' })

        if (id.charAt(0) === "Q" && id.length === 2) {
            this.setState({ showAdd: true })
            this.getPreferedFordonName(id);
        }
        else {
            this.setState({ showAdd: true, assettype: 'PU' })
            this.getPreferedName('', id)
        }
        /*assetCreator.getAssetTypes("MECH")
            .then((response) => response.json()).then(data => {

                this.setState({ assetTypes: data, showAdd : true })                

            })
            .catch(() => { throw new Error('Data Loading Error'); });
            */
        
        
    };

    addObjectClick = () => {

        if (this.state.parentid.length > 9) {

            this.setState({ preferedName: '', selectedId: this.state.parentid, description: '' })


            assetCreator.getAssetTypes("MECH")
                .then((response) => response.json()).then(data => {

                    this.setState({ assetTypes: data, showAdd: true })

                })
                .catch(() => { throw new Error('Data Loading Error'); });
        }
        else if (this.state.parentid.length <= 3 && this.state.parentid.charAt(0) !== "Q" && this.state.parentid.charAt(0) !== "V") {
            this.setState({ preferedName: 'V.' + this.state.parentid, showGeneric: true })
        }
        else if (this.state.parentid.charAt(0) === "Q" && this.state.parentid.length === 2) {
            this.setState({ showAdd: true })
            this.getPreferedFordonName(this.state.parentid);
        }
        else {
            this.setState({ showGeneric : true})
        }
    }

    getData(id) {

        
        return fetch(`${variables.API_URL}/api/assets/all/${id}`, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.token,
            }
        })
            .then((response) => response.json()).then(data => this.setState({ assetList: data }))
            .catch(() => { throw new Error('Data Loading Error'); });
    }


    setName(asset) {
        this.assetid = asset;
    }

    setNewId(id, tkn) {

       
        console.log(tkn);
        this.token = tkn
        //this.canEdit = ce;
        this.claims = getRoles(tkn);

        if (this.canEditNode(id)) {
            this.setState({ showAddButton: "MuiButtonBase-root MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeMedium MuiButton-textSizeMedium MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeMedium MuiButton-textSizeMedium css-1e6y48t-MuiButtonBase-root-MuiButton-root" })
        }
        else {
            this.setState({ showAddButton: "hidden'" })
        }

        this.setState({ parentid: id });
        this.getData(id);

        console.log(id);
    }

    refresh() {
        this.setState({ refresh: !this.state.refresh });
    }
    click = () => {
      //  alert(this.state.infoFields[2].value);
    }
    getPreferedName(assettype, parent) {
        var area = "MECH";
        console.log("Called get name")
        var n = parent + "-"
        this.setState({ preferedName: n });
        assetCreator.getPreferedName(assettype, parent, area).then((response) => response.json()).then(data => {
            console.log(data.id)
            this.setState({ preferedName: data.id })
        })
            .catch(() => { throw new Error('Data Loading Error'); })

    }


    getPreferedFordonName(parent) {
   
        console.log("Called get name")
        var n = parent + "-"
        this.setState({ preferedName: n });
        assetCreator.getPreferedFordonName(parent).then((response) => response.json()).then(data => {
            console.log(data.id)
            this.setState({ preferedName: data.id })
        })
            .catch(() => { throw new Error('Data Loading Error'); })

    }
    changeAssetItem(e) {
        this.getData();
    }

   
    renderButton(id) {
        if (id.length == 13 && this.canEditNode(id)) {
            return (



                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => this.handleClick(id)}
                >
                    Add object
                </Button >);
        }
        else {
            return null;
        }
    }
    canEditNode(node) {
        var canEdit = false;
        console.log("Can edit " + node)
        if (this.claims.roles.includes('ADMIN') || this.claims.roles.includes('LOCALADMIN.' + node.substr(0, 1))) {
            canEdit = true;
            console.log("Can edit true")
        }
        else if (node.substr(0, 1) == "V") {
            if (this.claims.roles.includes('LOCALADMIN.' + node.substr(2, 1))) {
                canEdit = true
            }
        }
      
        return canEdit;
    }

   
    getView = () => {

    }

    error(e) {
        console.log(e);
    }

    handleDescChange = (event) => {
        // 👇️ update textarea value
        this.setState({ description: event.target.value });
        console.log(event.target.value);
    };

    handleIDChange = (event) => {
        this.setState({ preferedName: event.target.value });
        console.log(event.target.value);
    }

    handleChange = (event) => {
        console.log("Selected typ")
        this.setState({ assettype: event.target.value });
        this.getPreferedName(event.target.value, this.state.selectedId);
    };

    commitGeneric = (event) => {
        //   alert(this.state.preferedName.substring(6, 8))
        this.setState({ addError: '' });

        if (this.state.parentid.charAt(0) === 'Q') {
            fetch(`${variables.API_URL}/api/assets/add/fordon/${this.state.preferedName}/${this.state.description}`,
                {

                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + this.token,
                    },

                }

            )
                .then(
                    (response) => response.json()
                )
                .then((data) => {

                    if (data.ok == true) {

                        this.setState({ showGeneric: false, addError: '' });



                    }
                    else {
                        this.setState({ addError: data.error })
                    }




                })
                .catch((e) => { console.error(e) });
        }
        else {
            fetch(`${variables.API_URL}/api/assets/add/generic/${this.state.preferedName}/${this.state.description}`,
                {

                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + this.token,
                    },

                }

            )
                .then(
                    (response) => response.json()
                )
                .then((data) => {

                    if (data.ok == true) {

                        this.setState({ showGeneric: false, addError: '' });



                    }
                    else {
                        this.setState({ addError: data.error })
                    }




                })
                .catch((e) => { console.error(e) });
        }
    }

     exportToExcel = () => {
        
         var tkn = this.token;

      
         this.backend.exportToExcel(tkn, this.state.parentid, this.downloadFile)
    }

    importExcel = () => {
        this.setState({ showImport: true });
    }

    closeImport = () => {
        this.setState({ showImport: false });
    }


    downloadFile = (blob) => {
      //  this.setState({ loading: false })
        const href = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = href;
        link.setAttribute('download', 'export.xlsx'); //or any other extension
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    commit = (event) => {

        const body = {
            parentId: this.state.selectedId,
            id: this.state.preferedName,
            assettype: this.state.assettype,
            text: this.state.description,
            responsible: ''
        }
        
        if (this.state.parentid.charAt(0) === 'Q') {
            fetch(`${variables.API_URL}/api/assets/add/fordon/${this.state.preferedName}/${this.state.description}`,
                {

                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + this.token,
                    },

                }

            )
                .then(
                    (response) => response.json()
                )
                .then((data) => {

                    if (data.ok == true) {

                        this.setState({ showAdd: false });


                        this.getData(this.state.parentid)
                        this.props.onCallback(12)


                    }
                    else {
                        this.setState({ addError: data.error })
                    }




                })
                .catch((e) => { console.error(e) });
        }
        else {
            fetch(`${variables.API_URL}/api/assets/`,
                {

                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + this.token,
                    },
                    body: JSON.stringify(body)
                }

            )
                .then(
                    (response) => response.json()
                ).
                then((data) => {
                    this.setState({ showAdd: false });


                    this.getData(this.state.parentid)



                })
                .catch((e) => { console.error(e) });


        }


    }

    render() {
       
        return (<div>

            <Modal
                open={this.state.showImport}
                onClose={this.closeImport}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={this.style}>
                <FileDropUploader />
                    <Button onClick={this.closeImport} >OK</Button>
                </Box>
            </Modal>

                <Modal
                    open={this.state.showGeneric}
                    onClose={this.handleCloseGen}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={this.style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            Add a new object
                        </Typography>

                       


                        <TextField value={this.state.preferedName} label="next Id" variant="outlined" onChange={this.handleIDChange} />
                        <TextField value={this.state.description} label="Description" onChange={this.handleDescChange} variant="outlined" />
                        <Button onClick={this.commitGeneric}  >Add</Button>
                        <Typography id="modal-modal-title" variant="h6" component="h3">
                            {this.state.addError}
                        </Typography>
                    </Box>
                </Modal>

                <Modal
                    open={this.state.showAdd}
                    onClose={this.handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={this.style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            Add a new child Asset to {this.state.name}
                        </Typography>
                        <InputLabel id="demo-simple-select-label">Asset type</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={this.state.assettype}
                            label="Asset type"
                            onChange={this.handleChange}
                        >
                            {this.state.assetTypes.map((item) => (
                                <MenuItem key={"mi" + item.assetTypeId} value={item.assetTypeId}>{item.assetTypeId + " " + item.nameSwe}</MenuItem>
                            ))}
                        </Select>
                        <TextField value={this.state.preferedName} label="next Id" variant="outlined" onChange={this.handleIDChange} />
                        <TextField value={this.state.description} label="Description" onChange={this.handleDescChange} variant="outlined" />
                        <Button onClick={this.commit}  >Add</Button>
                    </Box>
                </Modal>

                
                <Box sx={{ height: '600px', width: '700px' }}>

                    <h3>Positions</h3>
                    <Button onClick={this.addObjectClick} class = {this.state.showAddButton} >Add object</Button>
                <Button onClick={this.exportToExcel} >Export to Excel</Button>
                <Button onClick={this.importExcel}> Import from Excel</Button>



                    <DataGrid
                        className='datagrid'
                        columns={this.GridColDef}
                        rows={this.state.assetList}
                        pageSize={40}
                        rowsPerPageOptions={[10]}

                        processRowUpdate={this.changed}
                        onProcessRowUpdateError={this.error}
                        experimentalFeatures={{ newEditingApi: true }}


                    />
                </Box>
            </div>)
        
    }

}